import React, { useCallback, useState } from 'react'
import nautilusApi from '../../nautilusApi'
import { Box, Button, Input, Loading, Modal } from '@maui/elements'
import { Dropdown } from '@nautilusjs/component-core'
import debounce from 'lodash/debounce'
import { registerModal } from '../AppModal'

const ErrorMessage = ({ message }) => (
  <Box
    marginBottom='20px'
    marginRight='20px'
    marginLeft='20px'
    alignSelf='center'
    color='colorActionDestructive'
  >
    {message}
  </Box>
)

function AddUserModal({ id, name, ...modalProps }) {
  const { isOpen, onClose, orgUid } = modalProps
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [subscription, setSubscription] = useState('Paid')
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(false)

  const debouncedField = debounce((setter, value) => {
    setter(value)
  }, 500)

  const add = useCallback((values) => {
    if (!values.membership.user_attributes.first_name ||
        !values.membership.user_attributes.last_name ||
        !values.membership.user_attributes.email ||
        !values.membership.access) {
      setMessage('Please enter in all fields')
      return
    }

    setLoading(true)
    const url = `/organizations/${orgUid}/memberships`
    nautilusApi
      .fetch(url, {
        method: 'POST',
        body: JSON.stringify(values)
      })
      .then((res) => {
        setLoading(false)
        onClose()
      })
      .catch((e) => {
        const { error } = e.body
        setLoading(false)
        if (error.detail?.includes('User email has already been taken')) {
          setMessage('We can\'t complete your request. Please reach out to customer support for assistance. mandiant-support@google.com.')
        }
        if (error.detail === 'User Email domain must match organization domain.') {
          setMessage('Apologies, you are only able to add users from your own domain. If you need assistance adding users outside of your domain, please reach out to customer support. mandiant-support@google.com.')
        }
        if (error.detail === 'You are not authorized to perform this action') {
          setMessage('You are not authorized to perform this action')
        }
      })
  }, [onClose, orgUid])

  return (
    <Modal isOpen={isOpen} size="small">
      <Modal.Header onClose={onClose}>
        <Modal.Title>Add User</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Box marginBottom='16px'>
          <Box marginBottom='3px' fontWeight='bold'>First Name</Box>
          <Input
            width='100%'
            name='first_name'
            defaultValue={firstName}
            onChange={e => debouncedField(setFirstName, e.target.value)}
          />
        </Box>
        <Box marginBottom='16px'>
          <Box marginBottom='3px' fontWeight='bold'>Last Name</Box>
          <Input
            width='100%'
            name='last_name'
            defaultValue={lastName}
            onChange={e => debouncedField(setLastName, e.target.value)}
          />
        </Box>
        <Box marginBottom='16px'>
          <Box marginBottom='3px' fontWeight='bold'>Email</Box>
          <Input
            width='100%'
            name='email'
            defaultValue={email}
            onChange={e => debouncedField(setEmail, e.target.value)}
          />
        </Box>
        <Box width='100%'>
          <Box marginBottom='8px' fontWeight='bold'>Subscription</Box>
          <Dropdown trigger={subscription || 'Select one...'}>
            <Dropdown.Item onClick={() => setSubscription('Free')}>Free</Dropdown.Item>
            <Dropdown.Item onClick={() => setSubscription('Paid')}>Paid</Dropdown.Item>
          </Dropdown>
        </Box>
      </Modal.Body>
      { message && <ErrorMessage message={message} /> }
      <Modal.Footer>
        <Button variant='secondary' marginRight='spacePaddingMedium' onClick={modalProps?.onClose}>Cancel</Button>
        { loading && <Loading /> }
        { !loading &&
        <Button
          onClick={() => add({
            membership: {
              user_attributes: {
                first_name: firstName,
                last_name: lastName,
                email,
              },
              access: subscription,
            },
            organization_id: orgUid
          })}
        >
          Add
        </Button> }
      </Modal.Footer>
    </Modal>
  )
}

registerModal('AddUserModal', AddUserModal)

export default AddUserModal
